import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectGoogleAdsPage = lazy(
  () => import('~/features/onboarding/pages/connect-google-ads-screen'),
);

/** `connectionId` present → edit an existing Google Ads connection (prefill +
 *  PATCH); absent → the normal create flow. */
const searchSchema = z.object({
  connectionId: z.string().optional(),
});

function ConnectGoogleAdsRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectGoogleAdsPage connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/google-ads/',
)({
  validateSearch: searchSchema,
  component: ConnectGoogleAdsRouteComponent,
});
